export const LOGIN_URL = '/login'
export const ROOT_URL = '/'

export const INSTALLATIONS_URL = '/installations'
export const INSTALLATIONS_CREATE_URL = '/installations/create'
export const installationsEdit = (id?: number) => `${INSTALLATIONS_URL}/${id ? id : ':id'}/edit`

export const SSO_REALMS_URL = '/sso_realms'
export const SSO_REALMS_CREATE_URL = '/sso_realms/create'
export const ssoRealmsEdit = (id?: number) => `${SSO_REALMS_URL}/${id ? id : ':id'}/edit`

export const PLANS_URL = '/plans'
export const PLANS_SHOW_URL = '/plans/:id'
export const PLANS_CREATE_URL = '/plans/create'
export const plansEdit = (id?: number) => `${PLANS_URL}/${id ? id : ':id'}/edit`
export const plansShow = (id: number) => `/plans/${id}`

export const HOSPITALS_URL = '/hospitals'
export const HOSPITALS_SHOW_URL = '/hospitals/:id'
export const hospitalsEdit = (id?: number) => `${HOSPITALS_URL}/${id ? id : ':id'}/edit`
export const hospitalsSubscriptionsEdit = (id?: number) => `${HOSPITALS_URL}/${id ? id : ':id'}/subscriptions`
export const hospitalsShow = (id: number) => `/hospitals/${id}`

export const USERS_URL = '/users'
export const USERS_CREATE_URL = '/users/create'
export const usersEdit = (id?: number) => `${USERS_URL}/${id ? id : ':id'}/edit`

export const REPORTS_URL = '/reports'
export const REPORTS_DRUG_MODEL_ACCESS_URL = `${REPORTS_URL}/drug-model-access`
export const REPORTS_SUBSCRIPTION_EXPIRY_ACCESS_URL = `${REPORTS_URL}/subscription-expiry`

export const DOSEME_SITE_URL = window.env.REACT_APP_DOSEME_URL
